<template>
  <ContactUsModal ref="OpenContactUsModal" />
  <v-container fluid class="container-main" id="Home_Approach">
    <v-row justify="center">
      <v-col cols="12" md="11">
        <v-row justify="space-between">
          <v-col cols="10" sm="10" align-self="center">
            <h2 class="text-title">
              {{ t(`$vuetify.home.approach.title`) }}
            </h2>
          </v-col>
          <v-col cols="2" align-self="center" class="px-md-12">
            <div style="position: relative;line-height: 0;">
              <svg width="100%" class="svg-animation" viewBox="0 0 126 126" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M62.9163 7.36047C60.8402 7.36047 59.5483 5.9505 59.5483 3.65312V3.64819C59.5483 1.39026 60.8402 0 62.8917 0C64.5781 0 65.6729 0.976138 65.9441 2.28752L65.9638 2.36639H64.6718L64.657 2.31217C64.3858 1.54802 63.7694 1.10432 62.8966 1.10432C61.6145 1.10432 60.8452 2.04102 60.8452 3.63833V3.64326C60.8452 5.27509 61.649 6.25616 62.9311 6.25616C64.0061 6.25616 64.7458 5.59554 64.7705 4.59968L64.7754 4.49122H63.01V3.50029H66.0181V4.26937C66.0181 6.20193 64.8642 7.36047 62.9163 7.36047Z"
                  fill="#101010" />
                <path
                  d="M68.5429 7.44774L69.5789 0.409573L72.3891 0.823031C73.8917 1.04412 74.6861 2.01311 74.4858 3.37392L74.4844 3.38367C74.3451 4.3299 73.725 5.02101 72.8615 5.19794L73.9826 8.2481L72.5483 8.03706L71.5504 5.19938L70.1893 4.99911L69.8016 7.63293L68.5429 7.44774ZM70.3358 4.00411L71.7555 4.21299C72.5507 4.32999 73.0837 3.95993 73.195 3.20393L73.1964 3.19417C73.3048 2.45768 72.8732 1.93573 72.0829 1.81945L70.6876 1.61416L70.3358 4.00411Z"
                  fill="#101010" />
                <path
                  d="M76.8689 8.9292L78.9189 2.11685L83.3294 3.44344L83.0211 4.46789L79.829 3.50775L79.2763 5.3442L82.2938 6.25179L81.9968 7.23847L78.9794 6.33088L78.3955 8.2712L81.5877 9.23134L81.2794 10.2558L76.8689 8.9292Z"
                  fill="#101010" />
                <path
                  d="M84.6055 11.5212L87.6259 5.07987L91.7962 7.03433L91.342 8.00299L88.3236 6.58841L87.5094 8.32484L90.3625 9.662L89.9251 10.5949L87.0719 9.25779L86.2117 11.0924L89.23 12.507L88.7758 13.4757L84.6055 11.5212Z"
                  fill="#101010" />
                <path
                  d="M91.1391 14.7202L95.0654 8.78717L96.0195 9.41826L96.1599 15.4874L96.1846 15.5037L98.9354 11.3469L99.9883 12.0433L96.062 17.9763L95.1161 17.3507L94.9784 11.2596L94.9578 11.246L92.1961 15.4193L91.1391 14.7202Z"
                  fill="#101010" />
                <path
                  d="M98.1082 19.532L101.435 12.9606L102.42 13.8423L99.758 18.6665L99.7763 18.683L104.421 15.6352L105.281 16.4051L102.759 21.3544L102.777 21.3708L107.282 18.1981L108.267 19.0798L102.097 23.1049L101.182 22.2857L103.519 17.5281L103.497 17.5084L99.0227 20.3512L98.1082 19.532Z"
                  fill="#101010" />
                <path
                  d="M105.791 27.3565C104.459 25.7574 104.718 23.8557 106.457 22.4082L106.465 22.4019C108.201 20.9575 110.125 21.0567 111.45 22.6482C112.778 24.2436 112.519 26.1453 110.783 27.5896L110.776 27.5959C109.036 29.0434 107.122 28.9557 105.791 27.3565ZM106.64 26.6501C107.463 27.6392 108.744 27.6059 109.949 26.6031L109.957 26.5968C111.17 25.5876 111.414 24.3323 110.601 23.3546C109.79 22.3807 108.511 22.3862 107.295 23.3985L107.287 23.4048C106.07 24.4171 105.826 25.6724 106.64 26.6501Z"
                  fill="#101010" />
                <path
                  d="M109.316 31.7285L115.39 28.0225L116.87 30.4465C117.661 31.7426 117.424 32.9729 116.25 33.6894L116.242 33.6946C115.425 34.1928 114.497 34.1584 113.809 33.608L112.181 36.4206L111.425 35.1834L112.969 32.6015L112.252 31.4274L109.979 32.8142L109.316 31.7285ZM113.111 30.9034L113.858 32.128C114.277 32.814 114.903 32.9868 115.555 32.5887L115.563 32.5836C116.199 32.1958 116.324 31.5303 115.908 30.8486L115.173 29.645L113.111 30.9034Z"
                  fill="#101010" />
                <path
                  d="M113.503 39.074L120.052 36.2917L120.549 37.4623L114.985 39.8262L116.248 42.7982L115.264 43.2166L113.503 39.074Z"
                  fill="#101010" />
                <path
                  d="M116.309 46.1028L123.193 44.3035L123.851 46.8171C124.387 48.8681 123.466 50.4133 121.29 50.9819L121.281 50.9844C119.101 51.5543 117.505 50.677 116.966 48.6165L116.309 46.1028ZM117.671 47.0616L117.973 48.2158C118.334 49.5991 119.378 50.1415 120.948 49.7312L120.958 49.7287C122.494 49.3272 123.135 48.3291 122.777 46.9602L122.475 45.8059L117.671 47.0616Z"
                  fill="#101010" />
                <path d="M121.236 63.4269L122.33 63.4669L122.213 66.6446L121.119 66.6046L121.236 63.4269Z"
                  fill="#101010" />
                <path
                  d="M116.73 78.5924L123.464 80.8894L122.579 83.4837C122.114 84.8461 120.897 85.4674 119.548 85.0074L119.538 85.0042C118.194 84.5458 117.606 83.3084 118.071 81.946L118.545 80.5555L116.319 79.7962L116.73 78.5924ZM121.696 82.8492L122.069 81.7573L119.516 80.8866L119.143 81.9785C118.849 82.8417 119.143 83.5048 119.951 83.7801L119.96 83.7833C120.768 84.0587 121.402 83.7124 121.696 82.8492Z"
                  fill="#101010" />
                <path
                  d="M114.257 85.5419L119.422 91.057L118.768 92.3285L111.277 91.3381L111.888 90.1499L113.799 90.4558L115.009 88.1014L113.649 86.7256L114.257 85.5419ZM117.975 91.1003L115.736 88.835L114.818 90.6194L117.962 91.1266L117.975 91.1003Z"
                  fill="#101010" />
                <path
                  d="M109.978 93.4024L115.765 97.5417L114.113 99.8512C113.229 101.086 112.004 101.349 110.885 100.549L110.877 100.543C110.099 99.9868 109.767 99.1194 110.005 98.2709L106.779 97.873L107.622 96.6942L110.603 97.1045L111.404 95.9858L109.238 94.4368L109.978 93.4024ZM112.222 96.571L111.387 97.7378C110.919 98.3913 111.005 99.0344 111.626 99.479L111.634 99.4848C112.24 99.9179 112.901 99.7729 113.366 99.1233L114.187 97.9766L112.222 96.571Z"
                  fill="#101010" />
                <path
                  d="M103.851 101.167L108.203 105.362L109.682 103.828L110.452 104.571L106.619 108.546L105.849 107.803L107.324 106.274L102.972 102.079L103.851 101.167Z"
                  fill="#101010" />
                <path
                  d="M99.7152 105.277L104.064 110.908L103.159 111.607L97.3678 109.78L97.3444 109.798L100.391 113.743L99.3922 114.514L95.0432 108.883L95.9409 108.19L101.752 110.027L101.771 110.012L98.7121 106.051L99.7152 105.277Z"
                  fill="#101010" />
                <path
                  d="M92.3997 110.604L95.8823 116.807L91.8658 119.061L91.3421 118.128L94.2491 116.497L93.3103 114.825L90.5624 116.366L90.058 115.468L92.8059 113.926L91.8139 112.159L88.907 113.79L88.3832 112.857L92.3997 110.604Z"
                  fill="#101010" />
                <path
                  d="M85.4408 114.267L87.9827 120.911L85.3298 121.926C83.9112 122.468 82.744 122.012 82.2525 120.727L82.249 120.718C81.9073 119.825 82.1097 118.919 82.776 118.342L80.3052 116.231L81.6593 115.713L83.9187 117.699L85.2037 117.208L84.2524 114.721L85.4408 114.267ZM85.5631 118.147L84.2228 118.66C83.472 118.947 83.1884 119.53 83.4614 120.244L83.465 120.253C83.7309 120.948 84.3628 121.192 85.109 120.907L86.4263 120.403L85.5631 118.147Z"
                  fill="#101010" />
                <path
                  d="M69.4389 118.574L69.9583 125.669L65.4336 126L65.3555 124.933L68.6113 124.695L68.4576 122.595L65.4822 122.813L65.4066 121.781L68.382 121.563L68.17 118.667L69.4389 118.574Z"
                  fill="#101010" />
                <path
                  d="M59.0567 118.629C61.1322 118.781 62.3223 120.287 62.1571 122.544L62.1564 122.554C61.9915 124.806 60.5849 126.121 58.5193 125.97C56.4488 125.819 55.2586 124.313 55.4235 122.061L55.4242 122.051C55.5894 119.794 56.9813 118.477 59.0567 118.629ZM58.9761 119.731C57.6925 119.637 56.8272 120.582 56.7128 122.145L56.712 122.155C56.5969 123.729 57.3311 124.776 58.5999 124.869C59.8639 124.961 60.7474 124.037 60.8629 122.459L60.8636 122.449C60.9792 120.871 60.245 119.824 58.9761 119.731Z"
                  fill="#101010" />
                <path
                  d="M53.4609 118.132L51.9137 125.076L49.1412 124.459C47.6588 124.129 46.9372 123.104 47.2364 121.762L47.2385 121.752C47.4465 120.819 48.1154 120.175 48.9895 120.061L48.0941 116.937L49.5092 117.252L50.2972 120.155L51.6401 120.454L52.2191 117.856L53.4609 118.132ZM51.4213 121.436L50.0207 121.124C49.2361 120.949 48.6775 121.28 48.5113 122.025L48.5092 122.035C48.3473 122.762 48.7396 123.314 49.5194 123.487L50.896 123.794L51.4213 121.436Z"
                  fill="#101010" />
                <path
                  d="M37.7389 112.898L34.2563 119.101L30.2398 116.848L30.7635 115.915L33.6705 117.546L34.6094 115.874L31.8615 114.332L32.3659 113.433L35.1138 114.975L36.1057 113.208L33.1987 111.577L33.7224 110.644L37.7389 112.898Z"
                  fill="#101010" />
                <path
                  d="M31.545 109.299L27.5195 110.72L27.5105 110.731L27.1804 114.918L25.99 113.999L26.319 110.87L26.2761 110.837L23.3359 111.95L22.2079 111.079L26.2592 109.722L26.2682 109.71L26.5881 105.472L27.7474 106.367L27.4779 109.467L27.5131 109.494L30.4483 108.452L31.545 109.299Z"
                  fill="#101010" />
                <path
                  d="M22.8026 101.615C24.223 103.088 24.1045 104.996 22.4679 106.574L22.4644 106.577C20.8278 108.155 18.9194 108.193 17.5024 106.724C16.3661 105.545 16.2658 103.971 17.1795 102.83L17.2116 102.792L18.0775 103.69L18.0272 103.773C17.5852 104.487 17.6542 105.29 18.2976 105.957C19.1602 106.851 20.4248 106.735 21.5608 105.64L21.5643 105.637C22.7039 104.538 22.8665 103.272 22.0074 102.381C21.3777 101.728 20.5847 101.609 19.7919 102.051L19.7461 102.075L18.8802 101.177L18.9226 101.15C20.1 100.268 21.6663 100.437 22.8026 101.615Z"
                  fill="#101010" />
                <path
                  d="M18.9726 97.4558L13.1854 101.595L12.4451 100.561L17.362 97.0438L15.4826 94.4176L16.3529 93.7951L18.9726 97.4558Z"
                  fill="#101010" />
                <path
                  d="M13.4756 88.5443C14.3009 90.149 13.8721 91.6333 12.4731 92.3524L8.37697 94.4578L7.79523 93.3266L11.7993 91.2686C12.6764 90.8177 12.9758 89.9875 12.4933 89.0492C12.0108 88.111 11.1634 87.8757 10.2863 88.3266L6.28227 90.3847L5.7028 89.2579L9.79892 87.1525C11.1979 86.4334 12.6481 86.9352 13.4756 88.5443Z"
                  fill="#101010" />
                <path
                  d="M10.3355 81.1851C10.8625 82.7295 10.4816 83.995 9.29983 84.4866L9.23142 84.5151L8.83814 83.3627L8.89096 83.3342C9.43944 83.0482 9.5966 82.333 9.30841 81.4885C9.01863 80.6393 8.45908 80.2363 7.88035 80.4337L7.87568 80.4353C7.37163 80.6072 7.22035 81.0495 7.33448 81.9794L7.43193 82.7536C7.60875 84.1726 7.2156 85.036 6.21216 85.3782L6.2075 85.3798C5.02045 85.7795 3.86264 85.0127 3.36747 83.5616C2.86592 82.0919 3.31267 80.8664 4.44157 80.4033L4.51932 80.3716L4.9126 81.524L4.85978 81.5525C4.29878 81.8324 4.12548 82.4697 4.38342 83.2255C4.65717 84.0125 5.19306 84.3767 5.72978 84.1936L5.73444 84.192C6.21049 84.0297 6.36474 83.5655 6.25571 82.6964L6.15667 81.9175C5.96837 80.4191 6.32919 79.6136 7.37929 79.2555L7.38396 79.2539C8.63942 78.8257 9.77505 79.5427 10.3355 81.1851Z"
                  fill="#101010" />
                <path d="M8.26745 74.0505L1.27001 75.3426L1.03892 74.0919L8.03636 72.7997L8.26745 74.0505Z"
                  fill="#101010" />
                <path
                  d="M7.25514 66.0693L0.234131 68.7925L0.183523 67.4081L5.87347 65.3946L5.87257 65.37L0.0506083 63.7722L0 62.3878L7.20129 64.5962L7.25514 66.0693Z"
                  fill="#101010" />
                <path
                  d="M7.26112 59.289L0.188003 58.5109L0.691746 53.9339L1.75541 54.0509L1.39082 57.3636L3.29757 57.5734L3.64221 54.442L4.66666 54.5547L4.32202 57.6861L6.33661 57.9077L6.7012 54.595L7.76486 54.712L7.26112 59.289Z"
                  fill="#101010" />
                <path
                  d="M11.6888 41.4088C11.0504 42.9106 9.92194 43.599 8.71369 43.1767L8.64368 43.1523L9.12006 42.0316L9.17837 42.0457C9.77779 42.1986 10.3722 41.7708 10.7213 40.9495C11.0723 40.1237 10.9245 39.4503 10.3618 39.2112L10.3572 39.2093C9.86707 39.0011 9.45919 39.2295 8.92346 39.9983L8.47929 40.6398C7.66379 41.8147 6.7947 42.1954 5.81893 41.7808L5.8144 41.7789C4.66355 41.2846 4.31302 39.9412 4.91283 38.5301C5.52035 37.1008 6.67104 36.4862 7.82097 36.8944L7.90005 36.9226L7.42368 38.0433L7.36536 38.0293C6.76072 37.8635 6.20626 38.2225 5.89382 38.9575C5.57242 39.7263 5.72845 40.355 6.25037 40.5768L6.25491 40.5787C6.71784 40.7754 7.14251 40.5326 7.64147 39.8125L8.08757 39.1664C8.94755 37.9248 9.75389 37.5656 10.775 37.9994L10.7796 38.0014C12.0004 38.52 12.3676 39.8116 11.6888 41.4088Z"
                  fill="#101010" />
                <path
                  d="M14.1369 35.9827L8.06294 32.2767L10.4623 28.3463L11.3757 28.9036L9.63913 31.7483L11.2765 32.7474L12.9181 30.0583L13.7978 30.5951L12.1563 33.2841L13.8863 34.3397L15.6229 31.4949L16.5363 32.0522L14.1369 35.9827Z"
                  fill="#101010" />
                <path
                  d="M18.4123 29.3833L12.9428 24.8326L14.7597 22.6499C15.7312 21.4828 16.9724 21.3096 18.0299 22.1895L18.0375 22.1958C18.7729 22.8076 19.0399 23.6968 18.7412 24.5258L21.9294 25.158L21.0021 26.2721L18.0594 25.6454L17.1793 26.7027L19.2261 28.4056L18.4123 29.3833ZM16.4061 26.0593L17.324 24.9566C17.8382 24.3389 17.7999 23.6913 17.2123 23.2025L17.2048 23.1962C16.6324 22.72 15.962 22.8164 15.4509 23.4303L14.5488 24.5141L16.4061 26.0593Z"
                  fill="#101010" />
                <path
                  d="M25.0411 22.1304L18.4562 18.4771L19.4883 17.5526L24.676 20.6371L24.6944 20.6206L22.1987 15.1247L23.2307 14.2002L26.1392 21.1467L25.0411 22.1304Z"
                  fill="#101010" />
                <path d="M31.4966 16.9786L27.5704 11.0456L28.6314 10.3438L32.5577 16.2768L31.4966 16.9786Z"
                  fill="#101010" />
                <path
                  d="M39.5182 12.5602C37.6652 13.4286 35.8968 12.7002 34.9318 10.6424L34.9297 10.6379C33.9648 8.58007 34.5447 6.762 36.3932 5.89567C37.8756 5.20094 39.3983 5.61436 40.1833 6.84722L40.2087 6.88976L39.0791 7.41919L39.017 7.34483C38.4841 6.69619 37.7015 6.50217 36.862 6.89557C35.7369 7.4229 35.4387 8.65704 36.1085 10.0855L36.1106 10.0899C36.7825 11.5228 37.9286 12.0855 39.0493 11.5603C39.8709 11.1753 40.2397 10.4634 40.0769 9.57048L40.0694 9.51956L41.1991 8.99014L41.2111 9.03897C41.6654 10.4377 41.0006 11.8655 39.5182 12.5602Z"
                  fill="#101010" />
                <path
                  d="M44.6921 10.2795L42.642 3.46716L47.0525 2.14057L47.3608 3.16502L44.1686 4.12516L44.7213 5.96161L47.7388 5.05402L48.0357 6.0407L45.0182 6.94829L45.6021 8.88861L48.7943 7.92846L49.1026 8.95291L44.6921 10.2795Z"
                  fill="#101010" />
                <path
                  d="M54.7728 7.97462C53.1579 8.21221 51.9824 7.60781 51.7135 6.35676L51.6978 6.28431L52.9029 6.10701L52.9212 6.16411C53.103 6.75527 53.7778 7.03967 54.6609 6.90975C55.5488 6.77911 56.0468 6.30221 55.9578 5.6974L55.9571 5.69252C55.8795 5.16576 55.472 4.9367 54.5365 4.87999L53.7574 4.83518C52.3295 4.75127 51.5517 4.20793 51.3973 3.15928L51.3966 3.1544C51.2191 1.91481 52.1835 0.91582 53.7008 0.692582C55.2376 0.466472 56.3618 1.12826 56.6123 2.32222L56.6294 2.40442L55.4244 2.58172L55.406 2.52463C55.2326 1.92227 54.6372 1.63614 53.8469 1.75242C53.0231 1.87861 52.5675 2.3393 52.6501 2.90021L52.6508 2.90509C52.7241 3.40259 53.1526 3.63853 54.0273 3.68921L54.8114 3.73332C56.3195 3.82037 57.0462 4.32139 57.2077 5.41882L57.2085 5.42369C57.4016 6.73573 56.4901 7.72195 54.7728 7.97462Z"
                  fill="#101010" />
              </svg>
              <svg width="27%" class="svg-center-absolute" viewBox="0 0 22 22" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M21.943 5.97218L18.551 16.3618C18.5169 16.4665 18.4597 16.5622 18.3835 16.6418C18.3074 16.7214 18.2143 16.7828 18.1111 16.8214C18.008 16.8601 17.8975 16.875 17.7878 16.8651C17.6781 16.8552 17.5721 16.8208 17.4775 16.7643C17.4564 16.7514 15.1123 15.4011 10.9978 15.4011C6.88343 15.4011 4.53928 16.7514 4.51636 16.7652C4.42184 16.8211 4.31597 16.8552 4.20655 16.8647C4.09714 16.8743 3.98697 16.8591 3.88419 16.8204C3.78141 16.7817 3.68863 16.7204 3.61272 16.641C3.5368 16.5616 3.47969 16.4662 3.44558 16.3618L0.0554031 5.96943C-0.0129043 5.7614 -0.018168 5.53781 0.040274 5.32679C0.098716 5.11577 0.218254 4.92674 0.383852 4.78348C0.54945 4.64022 0.753712 4.54914 0.970947 4.52167C1.18818 4.49421 1.40869 4.53159 1.60473 4.62913L6.20594 6.92103L10.049 0.534882C10.1478 0.371081 10.2872 0.235583 10.4538 0.141527C10.6204 0.0474709 10.8084 -0.00195312 10.9997 -0.00195312C11.191 -0.00195312 11.379 0.0474709 11.5456 0.141527C11.7121 0.235583 11.8516 0.371081 11.9504 0.534882L15.7934 6.92103L20.3965 4.62913C20.5927 4.53145 20.8135 4.49412 21.031 4.52184C21.2485 4.54957 21.4529 4.64111 21.6183 4.78491C21.7838 4.92871 21.903 5.11832 21.9608 5.3298C22.0186 5.54127 22.0124 5.76513 21.943 5.9731V5.97218Z"
                  fill="#343330" />
              </svg>
            </div>
          </v-col>
        </v-row>
        <v-row justify="space-between" class="mt-8">
          <v-col cols="12" sm="7" align-self="start">
            <v-row justify="start">
              <v-col class="pr-0 pr-sm-3" cols="1" sm="2" md="1" align-self="start">
                <svg width="100%" style="vertical-align: middle; padding-top: .5rem;" viewBox="0 0 35 32" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M34.0613 10.0184C33.7093 9.61954 33.2765 9.30014 32.7916 9.0814C32.3067 8.86266 31.7809 8.74959 31.2489 8.74969H22.4992V6.24978C22.4992 4.59224 21.8408 3.00258 20.6687 1.83052C19.4966 0.658457 17.907 3.20461e-07 16.2494 3.20461e-07C16.0172 -0.000165932 15.7895 0.0643589 15.5919 0.18634C15.3943 0.30832 15.2346 0.482934 15.1307 0.690601L9.2278 12.4996H2.49991C1.83689 12.4996 1.20103 12.7629 0.732207 13.2318C0.263383 13.7006 0 14.3365 0 14.9995V28.749C0 29.412 0.263383 30.0479 0.732207 30.5167C1.20103 30.9855 1.83689 31.2489 2.49991 31.2489H29.374C30.2875 31.2492 31.1698 30.916 31.8551 30.3119C32.5404 29.7077 32.9815 28.8742 33.0957 27.9678L34.9707 12.9683C35.0371 12.4402 34.9904 11.9041 34.8336 11.3954C34.6768 10.8868 34.4135 10.4174 34.0613 10.0184ZM2.49991 14.9995H8.74969V28.749H2.49991V14.9995Z"
                    fill="#101010" />
                </svg>
              </v-col>
              <v-col cols="8" sm="10" md="11" align-self="center" class="fontSFProR title-text">
                {{ t(`$vuetify.home.approach.subtitle`) }}
              </v-col>
            </v-row>
          </v-col>
          <v-col offset="1" offset-sm="0" cols="10" md="4" lg="3" align-self="center"
            class="description-text fontSFProR">
            {{ t(`$vuetify.home.approach.text_right`) }}
          </v-col>
        </v-row>
        <v-divider class="divider-gray mt-12 mb-12" color="info"></v-divider>
        <v-row justify="center" class="mt-8 mb-0">
          <v-col cols="12" sm="10" md="6" class="pa-1" v-if="$vuetify.display.smAndUp">
            <v-card class="card-big pa-0" flat>
              <v-img src="../assets/img/Home/Approach/1.jpg" class="card-big-img" height="100%" cover width="100%"
                aspect-ratio="1">
                <div class="card-big-div">
                  <v-row justify="center" class="card-big-row-1 svg_absolute ma-0">
                    <v-col cols="12" sm="10" md="9" align-self="center">
                      <v-card-text class="card-big-title fontSFProR px-0">
                        {{ t(`$vuetify.home.approach.contact_us_title`) }}
                      </v-card-text>
                      <v-btn @click="OpenModal()" color="#101010" block variant="flat" size="large"
                        class="btn-see-all-2 fontSFProR">
                        {{ t(`$vuetify.home.approach.btn_get_in_touch`) }}
                        <template v-slot:append>
                          <v-icon>
                            <svg width="15" height="100%" viewBox="0 0 16 15" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M15.5 0.643545V11.7983C15.5 11.969 15.4322 12.1327 15.3115 12.2534C15.1908 12.3741 15.0271 12.4419 14.8565 12.4419C14.6858 12.4419 14.5221 12.3741 14.4014 12.2534C14.2807 12.1327 14.2129 11.969 14.2129 11.7983V2.19663L1.58226 14.8273C1.46027 14.941 1.29891 15.0028 1.13219 14.9999C0.965471 14.997 0.806399 14.9294 0.68849 14.8115C0.570581 14.6936 0.503042 14.5345 0.5001 14.3678C0.497159 14.2011 0.559044 14.0397 0.67272 13.9177L13.3034 1.28709H3.70167C3.53099 1.28709 3.36731 1.21929 3.24662 1.0986C3.12593 0.977912 3.05813 0.814224 3.05813 0.643545C3.05813 0.472866 3.12593 0.309178 3.24662 0.18849C3.36731 0.0678018 3.53099 0 3.70167 0H14.8565C15.0271 0 15.1908 0.0678018 15.3115 0.18849C15.4322 0.309178 15.5 0.472866 15.5 0.643545Z"
                                fill="#EEAC47" />
                            </svg>
                          </v-icon>
                        </template>
                      </v-btn>
                    </v-col>
                    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15 14V0C15 0 13.4085 6.60297 10.5 9.5C7.46588 12.5221 0.5 14 0.5 14H15Z"
                        fill="#E6E8EB" />
                    </svg>
                  </v-row>
                  <v-row class="ma-0" justify="end">
                    <v-col cols="6" class="pa-0" align-self="end">
                      <div class="svg_absolute">
                        <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M15 14V0C15 0 13.4085 6.60297 10.5 9.5C7.46588 12.5221 0.5 14 0.5 14H15Z"
                            fill="#E6E8EB" />
                        </svg>
                      </div>
                    </v-col>
                    <v-col cols="6" class="card-big-col-bottom pl-2 pt-2 pr-0 pb-0" align-self="end">
                      <v-card class="card-small-1 pa-0" flat>
                        <v-img src="../assets/img/Home/Approach/6.jpg" cover width="100%" height="100%"
                          class="py-6 px-4 card-small-img">
                          <div class="cards-div-flex">
                            <div>
                              <div class="px-3">
                                <svg width="40" height="51" viewBox="0 0 40 51" fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <g filter="url(#filter0_f_422_66)">
                                    <path
                                      d="M35 20.0089C35.0015 17.4811 34.3641 14.9938 33.1471 12.7783C31.9301 10.5627 30.1729 8.6906 28.0387 7.3359C25.9045 5.9812 23.4626 5.18783 20.9397 5.02947C18.4168 4.87111 15.8948 5.3529 13.608 6.43009C11.3212 7.50729 9.34366 9.14494 7.85914 11.191C6.37461 13.237 5.43124 15.625 5.11663 18.1331C4.80202 20.6413 5.12639 23.1883 6.0596 25.5376C6.99281 27.8869 8.5046 29.9622 10.4545 31.5708V44.5544C10.4544 44.7869 10.5137 45.0157 10.6268 45.2188C10.74 45.422 10.9032 45.5929 11.101 45.7152C11.2989 45.8375 11.5246 45.9072 11.757 45.9176C11.9893 45.928 12.2204 45.8789 12.4284 45.7748L20 41.9975L27.5733 45.7833C27.7632 45.8742 27.9713 45.9202 28.1818 45.918C28.5435 45.918 28.8903 45.7743 29.1461 45.5186C29.4018 45.2629 29.5455 44.916 29.5455 44.5544V31.5708C31.2516 30.1657 32.6255 28.4002 33.5686 26.4012C34.5116 24.4022 35.0005 22.2192 35 20.0089ZM7.72727 20.0089C7.72727 17.5816 8.44706 15.2088 9.7956 13.1905C11.1441 11.1723 13.0609 9.59928 15.3034 8.67038C17.546 7.74149 20.0136 7.49845 22.3943 7.972C24.775 8.44554 26.9618 9.61441 28.6781 11.3308C30.3945 13.0471 31.5634 15.2339 32.0369 17.6146C32.5105 19.9953 32.2674 22.4629 31.3385 24.7055C30.4096 26.948 28.8366 28.8648 26.8184 30.2133C24.8001 31.5618 22.4273 32.2816 20 32.2816C16.7462 32.278 13.6267 30.9838 11.3259 28.683C9.02506 26.3822 7.73088 23.2627 7.72727 20.0089ZM10.4545 20.0089C10.4545 18.121 11.0144 16.2755 12.0632 14.7057C13.1121 13.136 14.6029 11.9125 16.3471 11.1901C18.0913 10.4676 20.0106 10.2786 21.8622 10.6469C23.7139 11.0152 25.4147 11.9243 26.7497 13.2592C28.0846 14.5942 28.9937 16.295 29.362 18.1467C29.7304 19.9983 29.5413 21.9176 28.8188 23.6618C28.0964 25.406 26.8729 26.8968 25.3032 27.9457C23.7334 28.9945 21.8879 29.5544 20 29.5544C17.4692 29.5516 15.0429 28.5451 13.2533 26.7556C11.4638 24.966 10.4573 22.5397 10.4545 20.0089Z"
                                      fill="#E6E8EB" />
                                  </g>
                                  <defs>
                                    <filter id="filter0_f_422_66" x="0" y="0" width="40" height="50.9189"
                                      filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix"
                                        result="shape" />
                                      <feGaussianBlur stdDeviation="2.5" result="effect1_foregroundBlur_422_66" />
                                    </filter>
                                  </defs>
                                </svg>
                              </div>
                              <v-card-title class="fontSFProR cards-title">
                                {{ t(`$vuetify.home.approach.experienced_team.title`) }}
                              </v-card-title>
                            </div>
                            <div>
                              <v-card-text class="fontSFProR cards-text">
                                {{ t(`$vuetify.home.approach.experienced_team.description`) }}
                              </v-card-text>
                            </div>
                          </div>
                        </v-img>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
              </v-img>
            </v-card>
          </v-col>
          <v-col cols="12" sm="10" md="6">
            <v-row justify="center" class="row-cards">
              <v-col cols="12" sm="6" class="pa-1">
                <v-card class="card-small pa-0" flat>
                  <v-img src="../assets/img/Home/Approach/2.jpg" cover width="100%" height="100%"
                    class="py-6 px-4 card-small-img">
                    <div class="cards-div-flex">
                      <div>
                        <div class="px-3">
                          <svg width="68" height="51" viewBox="0 0 68 51" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_f_136_2392)">
                              <path
                                d="M32.092 44.5885C31.9918 44.9916 31.7606 45.3495 31.4351 45.6052C31.1096 45.861 30.7085 45.9999 30.2955 46C30.1395 46.0007 29.9839 45.9819 29.8325 45.9441L22.4244 44.0807C22.2181 44.0286 22.0223 43.9412 21.8456 43.8222L16.2895 40.0955C15.8809 39.8213 15.5973 39.3949 15.5011 38.9103C15.405 38.4256 15.5041 37.9224 15.7767 37.5113C16.0493 37.1002 16.4731 36.8149 16.9548 36.7182C17.4365 36.6214 17.9366 36.7211 18.3453 36.9954L23.6328 40.5427L30.7307 42.3292C30.9679 42.3871 31.1913 42.4915 31.3883 42.6365C31.5852 42.7815 31.7517 42.9642 31.8782 43.1742C32.0046 43.3841 32.0887 43.6171 32.1254 43.8599C32.1621 44.1026 32.1507 44.3502 32.092 44.5885ZM62.8103 22.1214C62.6584 22.5857 62.4165 23.0152 62.0986 23.385C61.7807 23.7548 61.3931 24.0576 60.9583 24.2758L55.4763 27.0336L51.9852 30.5483L42.725 39.865C42.4987 40.0924 42.2177 40.257 41.9093 40.3427C41.601 40.4285 41.2758 40.4324 40.9656 40.3541L26.1493 36.6274C25.924 36.5705 25.7112 36.4718 25.5219 36.3363L12.6688 27.1034L7.04783 24.2758C6.16936 23.834 5.50125 23.0592 5.19041 22.1219C4.87958 21.1846 4.95146 20.1614 5.39026 19.2774L11.1431 7.7038C11.5823 6.81997 12.3524 6.14778 13.284 5.83505C14.2156 5.52232 15.2326 5.59464 16.1112 6.03612L21.2182 8.5982L33.488 5.07184C33.8208 4.97605 34.1737 4.97605 34.5066 5.07184L46.7763 8.5982L51.8833 6.03612C52.762 5.59464 53.7789 5.52232 54.7105 5.83505C55.6422 6.14778 56.4122 6.81997 56.8514 7.7038L62.6043 19.2774C62.8237 19.7143 62.9549 20.1905 62.9903 20.6786C63.0256 21.1668 62.9645 21.6571 62.8103 22.1214ZM47.8899 29.3837L41.4749 24.2153C36.9513 27.9419 31.2076 28.4334 26.4479 25.3799C25.9797 25.0802 25.5844 24.6786 25.2912 24.2046C24.998 23.7306 24.8144 23.1964 24.7539 22.6414C24.6935 22.0865 24.7577 21.5249 24.942 20.9983C25.1262 20.4717 25.4256 19.9934 25.8182 19.5989C25.8238 19.5921 25.83 19.5858 25.8367 19.5802L36.222 9.44602L33.9996 8.80783L22.3271 12.1642L15.9909 24.9117L27.3809 33.0987L40.8405 36.483L47.8899 29.3837ZM52.1125 25.1353L45.8202 12.46H38.4537L28.4435 22.2425C31.3743 24.1268 35.9697 24.6462 40.0928 20.4653C40.4148 20.1388 40.8455 19.9436 41.3019 19.9174C41.7584 19.8911 42.2084 20.0357 42.5653 20.3232L50.5313 26.7448L52.1125 25.1353Z"
                                fill="#E6E8EB" />
                            </g>
                            <defs>
                              <filter id="filter0_f_136_2392" x="0" y="0" width="68" height="51"
                                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                                <feGaussianBlur stdDeviation="2.5" result="effect1_foregroundBlur_136_2392" />
                              </filter>
                            </defs>
                          </svg>
                        </div>
                        <v-card-title class="fontSFProR cards-title">
                          {{ t(`$vuetify.home.approach.exclusive_services.title`) }}
                        </v-card-title>
                      </div>
                      <div>
                        <v-card-text class="fontSFProR cards-text">
                          {{ t(`$vuetify.home.approach.exclusive_services.description`) }}
                        </v-card-text>
                      </div>
                    </div>
                  </v-img>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6" class="pa-1">
                <v-card class="card-small pa-0" flat>
                  <v-img src="../assets/img/Home/Approach/3.jpg" cover width="100%" height="100%"
                    class="py-6 px-4 card-small-img">
                    <div class="cards-div-flex">
                      <div>
                        <div class="px-3">
                          <svg width="54" height="54" viewBox="0 0 54 54" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_f_136_2406)">
                              <path
                                d="M48.0957 18.3694L42.5662 23.0838L44.2221 30.1023C44.3388 30.5943 44.3079 31.1097 44.1332 31.5841C43.9585 32.0586 43.6478 32.471 43.24 32.7699C42.8275 33.0727 42.3349 33.2473 41.8238 33.2718C41.3127 33.2962 40.8057 33.1695 40.3662 32.9074L34.0804 29.1751L27.7946 32.9074C27.3552 33.1695 26.8482 33.2962 26.337 33.2718C25.8259 33.2473 25.3333 33.0727 24.9209 32.7699C24.5132 32.4709 24.2027 32.0584 24.028 31.584C23.8534 31.1096 23.8223 30.5943 23.9387 30.1023L25.5946 23.0838L20.0632 18.3694C19.6761 18.039 19.3954 17.6014 19.2565 17.1118C19.1175 16.6222 19.1265 16.1025 19.2823 15.618C19.4382 15.1335 19.7338 14.706 20.1321 14.3892C20.5304 14.0724 21.0135 13.8805 21.5207 13.8377L28.8338 13.2189L31.6859 6.56966C31.8872 6.10352 32.2206 5.70649 32.6449 5.42756C33.0691 5.14863 33.5658 5 34.0735 5C34.5813 5 35.0779 5.14863 35.5022 5.42756C35.9265 5.70649 36.2599 6.10352 36.4612 6.56966L39.3133 13.2228L46.6245 13.8377C47.1328 13.8776 47.6178 14.0673 48.0182 14.383C48.4186 14.6986 48.7164 15.1259 48.874 15.6108C49.0315 16.0958 49.0416 16.6165 48.9031 17.1072C48.7645 17.5979 48.4836 18.0364 48.0957 18.3674V18.3694ZM18.6842 24.3154C18.5383 24.1693 18.365 24.0534 18.1742 23.9743C17.9834 23.8952 17.7789 23.8545 17.5724 23.8545C17.3659 23.8545 17.1614 23.8952 16.9706 23.9743C16.7799 24.0534 16.6066 24.1693 16.4606 24.3154L5.46052 35.3156C5.16565 35.6105 5 36.0104 5 36.4274C5 36.8444 5.16565 37.2444 5.46052 37.5392C5.75539 37.8341 6.15531 37.9998 6.57232 37.9998C6.98932 37.9998 7.38925 37.8341 7.68411 37.5392L18.6842 26.539C18.8303 26.3931 18.9462 26.2198 19.0253 26.029C19.1044 25.8382 19.1451 25.6337 19.1451 25.4272C19.1451 25.2207 19.1044 25.0162 19.0253 24.8254C18.9462 24.6347 18.8303 24.4613 18.6842 24.3154ZM21.8271 35.3156C21.6812 35.1695 21.5078 35.0536 21.3171 34.9745C21.1263 34.8954 20.9218 34.8547 20.7153 34.8547C20.5088 34.8547 20.3043 34.8954 20.1135 34.9745C19.9228 35.0536 19.7494 35.1695 19.6035 35.3156L8.60341 46.3159C8.4574 46.4619 8.34159 46.6352 8.26257 46.826C8.18355 47.0167 8.14289 47.2212 8.14289 47.4277C8.14289 47.6341 8.18355 47.8386 8.26257 48.0294C8.34159 48.2201 8.4574 48.3935 8.60341 48.5395C8.89827 48.8343 9.2982 49 9.7152 49C9.92168 49 10.1261 48.9593 10.3169 48.8803C10.5077 48.8013 10.681 48.6855 10.827 48.5395L21.8271 37.5392C21.9732 37.3933 22.0891 37.22 22.1682 37.0292C22.2473 36.8384 22.288 36.6339 22.288 36.4274C22.288 36.2209 22.2473 36.0164 22.1682 35.8257C22.0891 35.6349 21.9732 35.4616 21.8271 35.3156ZM33.7485 35.3156L22.7484 46.3159C22.4535 46.6107 22.2878 47.0107 22.2878 47.4277C22.2878 47.8447 22.4535 48.2446 22.7484 48.5395C23.0432 48.8343 23.4431 49 23.8601 49C24.2772 49 24.6771 48.8343 24.9719 48.5395L35.972 37.5392C36.2669 37.2446 36.4327 36.845 36.4329 36.4281C36.433 36.0113 36.2676 35.6115 35.973 35.3166C35.6784 35.0217 35.2787 34.856 34.8619 34.8558C34.4451 34.8556 34.0453 35.021 33.7504 35.3156H33.7485Z"
                                fill="#E6E8EB" />
                            </g>
                            <defs>
                              <filter id="filter0_f_136_2406" x="0" y="0" width="54" height="54"
                                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                                <feGaussianBlur stdDeviation="2.5" result="effect1_foregroundBlur_136_2406" />
                              </filter>
                            </defs>
                          </svg>

                        </div>
                        <v-card-title class="fontSFProR cards-title">
                          {{ t(`$vuetify.home.approach.comfort_and_style.title`) }}
                        </v-card-title>
                      </div>
                      <div>
                        <v-card-text class="fontSFProR cards-text">
                          {{ t(`$vuetify.home.approach.comfort_and_style.description`) }}
                        </v-card-text>
                      </div>
                    </div>
                  </v-img>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6" class="pa-1">
                <v-card class="card-small pa-0" flat>
                  <v-img src="../assets/img/Home/Approach/4.jpg" cover width="100%" height="100%"
                    class="py-6 px-4 card-small-img">
                    <div class="cards-div-flex">
                      <div>
                        <div class="px-3">
                          <svg width="54" height="41" viewBox="0 0 54 41" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_f_136_2413)">
                              <path
                                d="M49 18.7759C49 19.1413 48.8551 19.4917 48.5973 19.7501C48.3394 20.0084 47.9897 20.1536 47.625 20.1536H6.375C6.01033 20.1536 5.66059 20.0084 5.40273 19.7501C5.14487 19.4917 5 19.1413 5 18.7759C5 18.4104 5.14487 18.06 5.40273 17.8016C5.66059 17.5433 6.01033 17.3981 6.375 17.3981H11.1737L19.3378 6.13324C19.5852 5.79289 19.9072 5.51387 20.2789 5.31761C20.6507 5.12136 21.0625 5.01309 21.4825 5.00111C21.9026 4.98914 22.3198 5.07378 22.7021 5.24854C23.0844 5.4233 23.4217 5.68353 23.688 6.00924L25.8966 8.57531L25.9309 8.61492C26.0589 8.77601 26.2215 8.9061 26.4066 8.99552C26.5917 9.08494 26.7945 9.13138 27 9.13138C27.2055 9.13138 27.4083 9.08494 27.5934 8.99552C27.7785 8.9061 27.9411 8.77601 28.0691 8.61492L28.1034 8.57531L30.312 6.00924C30.5783 5.68353 30.9156 5.4233 31.2979 5.24854C31.6802 5.07378 32.0974 4.98914 32.5175 5.00111C32.9375 5.01309 33.3493 5.12136 33.7211 5.31761C34.0928 5.51387 34.4148 5.79289 34.6622 6.13324L42.8263 17.3981H47.625C47.9897 17.3981 48.3394 17.5433 48.5973 17.8016C48.8551 18.06 49 18.4104 49 18.7759ZM35.9375 22.9091C34.4157 22.9094 32.9474 23.4716 31.8133 24.4883C30.6791 25.5049 29.9586 26.9047 29.7895 28.4201H24.2105C24.041 26.9061 23.3211 25.5077 22.1882 24.4916C21.0553 23.4755 19.5887 22.913 18.0683 22.9113C16.5478 22.9097 15.08 23.469 13.9449 24.4826C12.8098 25.4962 12.0869 26.8931 11.9141 28.4067C11.7413 29.9203 12.1308 31.4447 13.0082 32.6889C13.8856 33.9331 15.1894 34.8101 16.671 35.1525C18.1525 35.4949 19.708 35.2787 21.0406 34.5452C22.3732 33.8117 23.3897 32.6122 23.8959 31.1756H30.1041C30.4822 32.2473 31.147 33.1941 32.026 33.9127C32.9049 34.6313 33.964 35.094 35.0877 35.2501C36.2113 35.4063 37.3561 35.2499 38.397 34.7981C39.438 34.3463 40.3349 33.6165 40.9898 32.6884C41.6447 31.7604 42.0324 30.6697 42.1105 29.5358C42.1886 28.4018 41.9541 27.2682 41.4326 26.2588C40.9111 25.2494 40.1227 24.403 39.1536 23.8123C38.1844 23.2215 37.0719 22.9091 35.9375 22.9091Z"
                                fill="#E6E8EB" />
                            </g>
                            <defs>
                              <filter id="filter0_f_136_2413" x="0" y="0" width="54" height="40.311"
                                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                                <feGaussianBlur stdDeviation="2.5" result="effect1_foregroundBlur_136_2413" />
                              </filter>
                            </defs>
                          </svg>
                        </div>
                        <v-card-title class="fontSFProR cards-title">
                          {{ t(`$vuetify.home.approach.discretion.title`) }}
                        </v-card-title>
                      </div>
                      <div>
                        <v-card-text class="fontSFProR cards-text">
                          {{ t(`$vuetify.home.approach.discretion.description`) }}
                        </v-card-text>
                      </div>
                    </div>
                  </v-img>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6" class="pa-1">
                <v-card class="card-small pa-0" flat>
                  <v-img src="../assets/img/Home/Approach/5.jpg" cover width="100%" height="100%"
                    class="py-6 px-4 card-small-img">
                    <div class="cards-div-flex">
                      <div>
                        <div class="px-3">
                          <svg width="40" height="51" viewBox="0 0 40 51" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_f_136_2420)">
                              <path
                                d="M35 20.0089C35.0015 17.4811 34.3641 14.9938 33.1471 12.7783C31.9301 10.5627 30.1729 8.6906 28.0387 7.3359C25.9045 5.9812 23.4626 5.18783 20.9397 5.02947C18.4168 4.87111 15.8948 5.3529 13.608 6.43009C11.3212 7.50729 9.34366 9.14494 7.85914 11.191C6.37461 13.237 5.43124 15.625 5.11663 18.1331C4.80202 20.6413 5.12639 23.1883 6.0596 25.5376C6.99281 27.8869 8.5046 29.9622 10.4545 31.5708V44.5544C10.4544 44.7869 10.5137 45.0157 10.6268 45.2188C10.74 45.422 10.9032 45.5929 11.101 45.7152C11.2989 45.8375 11.5246 45.9072 11.757 45.9176C11.9893 45.928 12.2204 45.8789 12.4284 45.7748L20 41.9975L27.5733 45.7833C27.7632 45.8742 27.9713 45.9202 28.1818 45.918C28.5435 45.918 28.8903 45.7743 29.1461 45.5186C29.4018 45.2629 29.5455 44.916 29.5455 44.5544V31.5708C31.2516 30.1657 32.6255 28.4002 33.5686 26.4012C34.5116 24.4022 35.0005 22.2192 35 20.0089ZM7.72727 20.0089C7.72727 17.5816 8.44706 15.2088 9.7956 13.1905C11.1441 11.1723 13.0609 9.59928 15.3034 8.67038C17.546 7.74149 20.0136 7.49845 22.3943 7.972C24.775 8.44554 26.9618 9.61441 28.6781 11.3308C30.3945 13.0471 31.5634 15.2339 32.0369 17.6146C32.5105 19.9953 32.2674 22.4629 31.3385 24.7055C30.4096 26.948 28.8366 28.8648 26.8184 30.2133C24.8001 31.5618 22.4273 32.2816 20 32.2816C16.7462 32.278 13.6267 30.9838 11.3259 28.683C9.02506 26.3822 7.73088 23.2627 7.72727 20.0089ZM10.4545 20.0089C10.4545 18.121 11.0144 16.2755 12.0632 14.7057C13.1121 13.136 14.6029 11.9125 16.3471 11.1901C18.0913 10.4676 20.0106 10.2786 21.8622 10.6469C23.7139 11.0152 25.4147 11.9243 26.7497 13.2592C28.0846 14.5942 28.9937 16.295 29.362 18.1467C29.7304 19.9983 29.5413 21.9176 28.8188 23.6618C28.0964 25.406 26.8729 26.8968 25.3032 27.9457C23.7334 28.9945 21.8879 29.5544 20 29.5544C17.4692 29.5516 15.0429 28.5451 13.2533 26.7556C11.4638 24.966 10.4573 22.5397 10.4545 20.0089Z"
                                fill="#E6E8EB" />
                            </g>
                            <defs>
                              <filter id="filter0_f_136_2420" x="0" y="0" width="40" height="50.9189"
                                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                                <feGaussianBlur stdDeviation="2.5" result="effect1_foregroundBlur_136_2420" />
                              </filter>
                            </defs>
                          </svg>
                        </div>
                        <v-card-title class="fontSFProR cards-title">
                          {{ t(`$vuetify.home.approach.commitment_to_excellence.title`) }}
                        </v-card-title>
                      </div>
                      <div>
                        <v-card-text class="fontSFProR cards-text">
                          {{ t(`$vuetify.home.approach.commitment_to_excellence.description`) }}
                        </v-card-text>
                      </div>
                    </div>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { useLocale } from "vuetify";
import ContactUsModal from "./Modals/ContactUsModal.vue";

export default {
  name: 'ApproachPage',
  setup() {
    const { t } = useLocale();
    return {
      t,
    };
  },
  components: {
    ContactUsModal
  },
  methods: {
    OpenModal() {
      this.$refs.OpenContactUsModal.dialog = true;
      //this.$refs.OpenContactUsModal.property = card;
    },
  },
  mounted() {
    /*  const row = document.querySelector('.row-cards');
     let startY;
     let startScrollLeft;
 
     row.addEventListener('touchstart', (e) => {
       startY = e.touches[0].pageY;
       startScrollLeft = row.scrollLeft;
     });
     row.addEventListener('touchmove', (e) => {
       const currentY = e.touches[0].pageY;
       const deltaY = currentY - startY;
       if (deltaY < 0 && row.scrollLeft + window.innerWidth < row.scrollWidth) {
         //down
         e.preventDefault();
         row.scrollLeft = startScrollLeft - deltaY;
       } else if (deltaY > 0 && row.scrollLeft > 0) {
         //up
         e.preventDefault();
         row.scrollLeft = startScrollLeft - deltaY;
       }
     }); */
  },
}
</script>

<style scoped>
.btn-see-all-2 {
  border-radius: 15px;
  color: #E6E8EB;
  font-size: 1.3rem;
  text-transform: inherit;
  letter-spacing: 0.5px;
}

.card-big-div {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.svg_absolute {
  position: relative;
  height: 100%;
}

.svg_absolute svg {
  position: absolute;
  right: 0%;
  bottom: 0%;
}

.card-big-col-bottom {
  aspect-ratio: 0.665;
  background: #E6E8EB;
  border-top-left-radius: 15px;
}


.card-big-title {
  letter-spacing: 0px;
  text-align: left;
  color: #FFF;
  text-shadow: 19px 4px 45px rgba(0, 0, 0, 0.80);
  font-size: 1.6rem;
}

.cards-div-flex {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
}

.cards-text {
  color: #E6E8EB;
  font-size: 1.05rem;
  line-height: 1.6rem;
  min-height: 126px;
  white-space: normal;
  text-wrap: balance;
  letter-spacing: 0px;
}

.cards-title {
  color: #E6E8EB;
  font-size: 1.6rem;
  white-space: normal;
  text-wrap: balance;
  letter-spacing: 0px;
}

.card-small-1 {
  background: #101010;
  aspect-ratio: 0.66;
  border-radius: 15px;
  border: 1px solid rgba(154, 154, 155, 0.50);
}

.card-small {
  background: #101010;
  aspect-ratio: 0.67;
  border-radius: 15px;
  border: 1px solid rgba(154, 154, 155, 0.50);
}

.card-big {
  border-radius: 15px;
  height: 100%;
}

.divider-gray {
  border-width: 1px;
  border-color: rgba(154, 154, 155, 0.36);
  opacity: 1;
}

.description-text {
  font-size: 0.9rem;
  color: #737475;
}

.text-title {
  color: #343330;
  font-weight: 300;
  font-size: 5.5rem;
  line-height: 7rem;
  text-align: left;
  text-transform: uppercase;
}

.title-text {
  font-size: 1.3rem;
  color: #000000;
}

@media (min-width: 950px) and (max-width: 1150px) {
  .cards-title {
    font-size: 1.4rem;
  }

  .cards-text {
    font-size: 0.85rem;
    line-height: 1.3rem;
  }

}

@media (min-width: 600px) and (max-width: 960px) {
  .text-title {
    font-size: 3.8rem;
    font-weight: 300;
    line-height: 5rem;
  }

  .btn-see-all-2 {
    font-size: 1rem;
  }

}

@media (max-width: 600px) {
  .text-title {
    font-size: 2.1rem;
    font-weight: 400;
    line-height: 3rem;
  }

  /*  .row-cards {
    overflow: auto;
    display: flex;
    flex-wrap: nowrap;
    white-space: nowrap;
    justify-content: flex-start !important;

  }

  .row-cards {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .row-cards::-webkit-scrollbar {
    display: none;
  } */

  .btn-see-all-2 {
    font-size: 1rem;
  }
}

.svg-center-absolute {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.svg-animation {
  overflow: visible;
  transform-origin: 50% 50%;
  animation-name: svg-anim-2;
  animation-duration: 18s;
  animation-direction: normal;
  animation-timing-function: linear;
  transform: rotate(0deg);
  animation-iteration-count: infinite;
}

@keyframes svg-anim-2 {
  from {
    transform: rotate(-360deg);
  }

  to {
    transform: rotate(0deg);
  }
}

.container-main {
  padding-top: 10vh;
  padding-bottom: 5vh;
}
</style>
<style>
#Home_Approach .card-small-img .v-img__img {
  transition: 8s;
  object-position: left;
}

#Home_Approach .card-small:hover .card-small-img .v-img__img {
  object-position: right;
  transform: scale(1.2);
}

#Home_Approach .card-big-img .v-img__img {
  transition: 6s;
  object-position: left;
}

#Home_Approach .card-big-img:hover:not(.card-big-col-bottom:hover) .v-img__img {
  object-position: right;
  transform: scale(1.2);
}
</style>